import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NzShowUploadList, NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-preview-upload',
  templateUrl: './preview-upload.component.html',
  styleUrls: ['./preview-upload.component.scss']
})
export class PreviewUploadComponent implements OnInit {
  @Input() fileList: NzUploadFile[] = [];
  previewImage: string | undefined = '';
  previewVisible = false;
  @Input() nzName;
  @Input() nzListType;
  @Input() isImageStatus: boolean;//true:现况区域照片图片上传;false:上传需求方案上传
  @Output() isUpload = new EventEmitter<NzUploadFile[]>();
  // @Output() isRemovedOldUpload = new EventEmitter<NzUploadFile[]>();
  @Input() nzDisabled;
  @Input() disabled;
  @Input() nzShowButton = true;
  @Input() nzShowUploadList: NzShowUploadList;

  ngOnInit(): void {
    // do something
  }

  removeStatus(event) {
    this.fileList = [];
    if (event['type'] && event['type'] === 'removed') {
      this.fileList = event['fileList'];
    }
    this.isUpload.emit(this.fileList);
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    file.status = 'done';
    file.originFileObj = file as any; // File
    this.fileList = this.fileList.concat(file);
    this.isUpload.emit(this.fileList);
    return false;
  };

  handlePreview = async (file: NzUploadFile): Promise<void> => {
    // 预览图片,文件不用预览
    if ((!file.url && !file.preview) || (!file.url)) {
      file.preview = await getBase64(file.originFileObj);
      this.previewImage = file.url || file.preview;
      this.previewVisible = file.preview.includes('image') ? true : false;
    }
    else if (!!file.url) {
      this.previewImage = file.url;
      this.previewVisible = file.url.includes('bill_applay/images/') ? true : false;
      if (!this.previewVisible) {
        window.open(file.url, '_blank');
      }
    }
  }

  // download = (file: NzUploadFile): boolean => {
  //   if (!!file.url) {
  //     if (file.url.includes('bill_applay/images/')) {
  //       fetch(file.url, {
  //         method: 'get',
  //         mode: 'cors',
  //         cache: 'no-cache',
  //       })
  //         .then((response) => response.blob())
  //         .then((data) => {
  //           const downloadUrl = window.URL.createObjectURL(new Blob([data]));
  //           const link = document.createElement('a');
  //           link.href = downloadUrl;
  //           link.setAttribute('download', file.name);
  //           document.body.appendChild(link);
  //           link.click();
  //           link.remove();
  //         });
  //     }
  //     else {
  //       window.open(file.url, '_blank');
  //     }
  //   }
  //   return true;
  // }
    download = (file: NzUploadFile): boolean => {
    if (!!file.url) {
      if (file.url.includes('bill_applay/images/')) {
        // 尝试直接通过链接下载来绕过CORS问题
        const link = document.createElement('a');
        link.href = file.url;
        link.setAttribute('download', file.name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      else {
        window.open(file.url, '_blank');
      }
    }
    return true;
  }

}

const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
